export const getCategoryById = (id: number, categories: any) => {
  const category = categories.find((category: any) => category.id === id);
  return (
    category && categories.find((category: any) => category.id === id).label
  );
};
